import { render, staticRenderFns } from "./ProviderEditor.vue?vue&type=template&id=60e4501a&scoped=true"
import script from "./ProviderEditor.vue?vue&type=script&lang=js"
export * from "./ProviderEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e4501a",
  null
  
)

export default component.exports